import React, { useState, useEffect } from "react";
import Header from "./Header.js";
import Loader from "./Loader.js";
import GreyArrow from "../assets/greyLeftAr.png";
import FilterIcon from "../assets/filterIcon.png";
import Search from "../assets/search.png";
import GuestIcon from "../assets/guestIcon.png";
import dummyImg1 from "../assets/addImgImg.png";
import dummyImg2 from "../assets/alexander-hipp-iEEBWgY_6lA-unsplash.jpg";
import dummyImg3 from "../assets/forgotScreen.png";
import dummyImg4 from "../assets/loginImg.png";
import DatePicker from "react-datepicker";
import { ArrowLeft } from "lucide-react";
import { GuestManagementPageText } from "../CommonJquery/WebsiteText.js";
import {
  server_post_data,
  get_workshop_enquiry_report,
} from "../ServiceConnection/serviceconnection.js";
import {
  handleError,
  computeTodayDate,
  computeplussevendays,
  goBack,
  formatToYYYYMMDD,
  mondayDayYearFormat,
} from "../CommonJquery/CommonJquery.js";
import { Button } from "@mui/material";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import JSZip from "jszip";
import { saveAs } from "file-saver";
function ACREnquiries() {
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [editStaffData, seteditStaffData] = useState([]);
  // Set initial state using useState hook
  const [startDate, setStartDate] = useState(computeplussevendays());
  const [endDate, setEndDate] = useState(computeTodayDate());
  const [searchfilter, setSearchFilter] = useState("");
  const [filteredData, setfilteredData] = useState([]);
  const [flagData, setflagData] = useState("1");
  const [selectedValue, setSelectedValue] = useState("Name"); // State to hold the selected value
  const handleSelect = (event) => {
    setSelectedValue(event.target.value); // Update the selected value when an option is selected
  };
  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Get paginated data
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData
    ? filteredData.slice(indexOfFirstItem, indexOfLastItem)
    : [];
  const totalPages = filteredData
    ? Math.ceil(filteredData.length / itemsPerPage)
    : 0;

  //console.log("currentItems:", currentItems);

  // Handler for page changes
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Render pagination buttons
  const renderPaginationButtons = () => {
    const buttons = [];

    // Previous button
    buttons.push(
      <li className="cust_hist_page_item" key="prev">
        <button
          className="cust_hist_page_link cust_hist_page_prev"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <span className="sr-only">Previous</span>
          <svg
            className="cust_hist_page_icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </li>
    );

    // Page buttons
    // Show max 5 page buttons with current page in the middle when possible
    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, startPage + 4);

    // Adjust startPage if endPage is at maximum
    if (endPage === totalPages) {
      startPage = Math.max(1, endPage - 4);
    }

    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <li className="cust_hist_page_item" key={i}>
          <button
            className={`cust_hist_page_link ${
              currentPage === i ? "cust_hist_page_active" : ""
            }`}
            onClick={() => handlePageChange(i)}
          >
            {i}
          </button>
        </li>
      );
    }

    // Next button
    buttons.push(
      <li className="cust_hist_page_item" key="next">
        <button
          className="cust_hist_page_link cust_hist_page_next"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages || totalPages === 0}
        >
          <span className="sr-only">Next</span>
          <svg
            className="cust_hist_page_icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </li>
    );

    return buttons;
  };

  useEffect(() => {
    const flag = "1";
    let call_id = "0";
    master_data_get(" ", " ", flag, call_id);
  }, []);

  const search_data = () => {
    const flag = "2";
    const call_id = "0";
    setCurrentPage(1);
    master_data_get(startDate, endDate, flag, call_id);
  };

  const master_data_get = async (start_date, end_date, flag, call_id) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    setflagData(flag);
    fd.append("start_date", formatToYYYYMMDD(start_date));
    fd.append("end_date", formatToYYYYMMDD(end_date));
    fd.append("flag", flag);
    await server_post_data(get_workshop_enquiry_report, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          console.log("Console:", Response.data.message);

          seteditStaffData(Response.data.message.enquiry_data);
          setfilteredData(Response.data.message.enquiry_data);
        }

        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  const handleSearch = (event) => {
    const searchValue = event.target.value.toLowerCase();
    setSearchFilter(searchValue);
    setCurrentPage(1);

    const filteredDatashow = editStaffData.filter((row) => {
      const driver = row.driver_details?.[0] || {};
      const car = row.car_details?.[0] || {};
      const booking = row.booking_details?.[0] || {};

      const fieldsToSearch = [
        driver.name,
        driver.email,
        driver.mobile_no,
        car.car_tagline, // fleet number
        car.car_name,
        car.car_no,
        booking.per_day_rent + booking.per_day_surcharges,
        row.payment_mode,
        row.total_amount?.toString(),
        row.rent?.toString(),
        row.tolls?.toString(),
        row.damagefees?.toString(),
        row.deposit?.toString(),
        row.entry_date?.split("T")[0], // date for "Last Pay"
      ];

      return fieldsToSearch.some((field) =>
        field?.toString().toLowerCase().includes(searchValue)
      );
    });

    setfilteredData(filteredDatashow);
  };

  const handleDateChange = (date) => {
    setStartDate(date);
  };

  const downloadCSV = () => {
    const headers = [
      "Driver Name",
      "Car Name",
      "Fleet",
      "Rate per day",
      "Last Payment Date",
      "Payment Mode",
      "Total Balance",
      "Total Dues",
      "Breakup - Rent, Tolls, Damage",
    ];

    const rows = editStaffData.map((item) => {
      const driver = item.driver_details?.[0] || {};
      const car = item.car_details?.[0] || {};
      const booking = item.booking_details?.[0] || {};

      const driverName = driver.name || "";
      const carName = car.car_name || "";
      const fleet = car.car_tagline || "";
      const ratePerDay = booking.per_day_rent || 0;
      const lastPaymentDate = item.entry_date?.split("T")[0] || "";
      const paymentMode = item.payment_mode || "";
      const totalBalance = item.total_amount || 0;
      const totalDues = booking.total_due || 0;
      const breakup = `Rent: ${booking.due_rent || 0}, Tolls: ${
        booking.due_tolls || 0
      }, Damage: ${booking.due_damage || 0}`;

      return [
        driverName,
        carName,
        fleet,
        ratePerDay,
        lastPaymentDate,
        paymentMode,
        totalBalance,
        totalDues,
        breakup,
      ];
    });

    const csvContent =
      "data:text/csv;charset=utf-8," +
      [headers, ...rows].map((row) => row.join(",")).join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "payment_report.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const [selectedDriver, setSelectedDriver] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showModal, setShowModal] = useState(false);

  const handleViewImages = (driver) => {
    setSelectedDriver(driver);
    console.log(driver);
    setCurrentImageIndex(0);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedDriver(null);
  };

  const handleDownloadAllImages = async () => {
    if (!selectedDriver || !Array.isArray(selectedDriver.images)) return;

    const zip = new JSZip();
    const folderName = selectedDriver.name.replace(/\s+/g, "_");
    const folder = zip.folder(folderName);

    for (let i = 0; i < selectedDriver.images.length; i++) {
      const imageUrl = selectedDriver.images[i];
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      folder.file(`image_${i + 1}.jpg`, blob);
    }

    const content = await zip.generateAsync({ type: "blob" });
    saveAs(content, `${folderName}_images.zip`);
  };

  const handleDownloadAllImages2 = async (option) => {
    let selectedRow = option;
    if (!selectedRow || !Array.isArray(selectedRow.images)) return;

    const zip = new JSZip();
    const folderName = selectedRow.name.replace(/\s+/g, "_");
    const folder = zip.folder(folderName);

    for (let i = 0; i < selectedRow.images.length; i++) {
      const imageUrl = selectedRow.images[i];
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      folder.file(`image_${i + 1}.jpg`, blob);
    }

    const content = await zip.generateAsync({ type: "blob" });
    saveAs(content, `${folderName}_images.zip`);
  };
  return (
    <div className="dashboard">
      {showLoaderAdmin && <Loader />}

      <div className="dashboard_container">
        <div className="page_content">
          <div className="page_content_container">
            <Header />
            <div className="pageCntn_head">
              <div className="pageNameDiv">
                <p className="breadcrumb-item">Repair Enquiries</p>
                <img src={GreyArrow} alt="Rapid Car Leasing" />
              </div>
              <div className={` alignCol bottomAlgin col-xl-3 mb-0`}>
                <div className="pageActionBtns">
                  <button
                    className="CSVBTN"
                    style={{ height: "38px" }}
                    onClick={downloadCSV}
                  >
                    Download Excel
                  </button>
                </div>
              </div>
              <Button
                onClick={goBack}
                startIcon={
                  <ArrowLeft size={17} style={{ marginBottom: "2px" }} />
                }
                className="Back_bttn_page"
              >
                Back
              </Button>
            </div>

            <div className="page_body">
              <div className="viewStaff">
                <div className="viewStaff_head">
                  <div className="row m-0">
                    <div className="col-lg-2 col-sm-4 bottomAlgin">
                      <label className="labelView">
                        {GuestManagementPageText.Start_Date}
                      </label>
                      <div className="person__calenderFrame_image image_icon_position1 ">
                        <DatePicker
                          selected={startDate}
                          onChange={handleDateChange}
                          className="form-control input_field_custom4"
                          maxDate={computeTodayDate()}
                          dateFormat="MM-dd-yyyy"
                          placeholderText="MM-DD-YYYY"
                        />
                      </div>
                    </div>
                    <div className="col-lg-2 col-sm-4 bottomAlgin">
                      <label className="labelView">
                        {GuestManagementPageText.End_Date}
                      </label>
                      <div className="person__calenderFrame_image image_icon_position1 ">
                        <DatePicker
                          selected={endDate}
                          onChange={(date) => setEndDate(date)}
                          className="form-control input_field_custom4"
                          maxDate={computeTodayDate()}
                          minDate={startDate}
                          dateFormat="MM-dd-yyyy"
                          placeholderText="MM-DD-YYYY"
                        />
                      </div>
                    </div>
                    <div className="col-xl-1 col-md-2 bottomAlgin">
                      <div className="inputDiv2 p-0">
                        <button
                          type="button"
                          className="btnSearch w-100 h-100"
                          style={{ left: "auto", right: "auto" }}
                          onClick={() => search_data()}
                        >
                          {GuestManagementPageText.Search_text}
                        </button>
                      </div>
                    </div>

                    <div
                      className="col-xl-3 col-md-4 bottomAlgin"
                      style={{ marginLeft: "auto", marginRight: "0" }}
                    >
                      <div className="inputDiv2">
                        <label className="labelPointer" htmlFor="selectFilter">
                          <img src={Search} alt="Rapid Car Leasing" />
                        </label>
                        <input
                          type="text"
                          placeholder={GuestManagementPageText.Guest_Filter}
                          value={searchfilter}
                          onChange={(e) => handleSearch(e)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{ padding: "0 10px" }}>
                  <div className="cust_hist_card" style={{ padding: "0 10px" }}>
                    <div className="reservationHistoryTable">
                      <div
                        className="historyTableContainer stickyTableheigh274"
                        style={{ overflowX: "auto" }}
                      >
                        <table className="table margin_class_table">
                          <thead className="stickyHeaderClss">
                            <tr>
                              <th scope="col">Sr.No.</th>
                              <th scope="col">Date</th>
                              <th scope="col">
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                  }}
                                >
                                  <img
                                    src={GuestIcon}
                                    alt="Rapid Car Leasing"
                                    style={{
                                      height: "15px",
                                      width: "15px",
                                      marginRight: "0.2rem",
                                    }}
                                  />
                                  <span className="fontWeight600">
                                    Driver Details
                                  </span>
                                </div>
                              </th>
                              <th scope="col">Vehicle Details</th>
                              <th scope="col">Discription</th>
                              <th scope="col">Images</th>
                            </tr>
                          </thead>
                          <tbody>
                            {currentItems && currentItems.length > 0 ? (
                              currentItems.map((option, index) => (
                                <tr
                                  className="historyTableRow h-auto"
                                  key={index}
                                >
                                  <td>
                                    <div
                                      className="historyTableRowText height50 historyName h-auto"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      {indexOfFirstItem + index + 1}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText justify-content-start historyName h-auto">
                                      {mondayDayYearFormat(option?.entry_date)}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText justify-content-start historyName h-auto">
                                      <strong>{option?.name}</strong>
                                      {option?.email}
                                      <br />
                                      {option?.contact_number}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText justify-content-start historyName h-auto">
                                      Year: {option.year_of_manufacturing}
                                      <br />
                                      Make: {option.vehicleMake}
                                      <br />
                                      Modal: {option.vehicleModel}
                                    </div>
                                  </td>
                                  <td>
                                    <div
                                      className="historyTableRowText justify-content-start historyName h-auto"
                                      style={{
                                        maxWidth: "300px",
                                        marginTop: "0",
                                      }}
                                    >
                                      {option.description}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText justify-content-start h-auto historyName">
                                      <button
                                        className="tbnWhiteNew mb-1"
                                        style={{ width: "120px" }}
                                        onClick={() => handleViewImages(option)}
                                      >
                                        View Images
                                      </button>
                                      <button
                                        className="tbnWhiteNew"
                                        style={{ width: "120px" }}
                                        onClick={() => {
                                          handleDownloadAllImages2(option);
                                        }}
                                      >
                                        Download
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={6} className="text_align_center">
                                  No Results Found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                        <div className="cust_hist_card_footer">
                          <div className="cust_hist_pagination_info">
                            {filteredData && filteredData.length > 0 ? (
                              <>
                                Showing{" "}
                                <span className="cust_hist_pagination_bold">
                                  {indexOfFirstItem + 1}
                                </span>{" "}
                                to{" "}
                                <span className="cust_hist_pagination_bold">
                                  {Math.min(
                                    indexOfLastItem,
                                    filteredData.length
                                  )}
                                </span>{" "}
                                of{" "}
                                <span className="cust_hist_pagination_bold">
                                  {filteredData.length}
                                </span>{" "}
                                Drivers
                              </>
                            ) : (
                              <>
                                Showing{" "}
                                <span className="cust_hist_pagination_bold">
                                  0
                                </span>{" "}
                                Driver
                              </>
                            )}
                          </div>
                          <div className="cust_hist_pagination">
                            <nav aria-label="Pagination">
                              <ul className="cust_hist_pagination_list">
                                {renderPaginationButtons()}
                              </ul>
                            </nav>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* React Bootstrap Modal */}
      {selectedDriver &&
        selectedDriver.images &&
        Array.isArray(selectedDriver.images) && (
          <Modal show={showModal} onHide={handleClose} size="md" centered>
            <Modal.Header closeButton>
              <Modal.Title>Images - {selectedDriver?.driverName}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="text-center">
              {selectedDriver?.images?.length > 0 ? (
                <>
                  <img
                    src={selectedDriver.images[currentImageIndex]}
                    alt="Vehicle"
                    style={{
                      maxHeight: "300px",
                      width: "100%",
                      objectFit: "contain",
                    }}
                  />
                  <div className="mt-3 d-flex justify-content-between">
                    <li className="cust_hist_page_item" key="prev">
                      <button
                        className="cust_hist_page_link cust_hist_page_prev"
                        onClick={() =>
                          setCurrentImageIndex(currentImageIndex + 1)
                        }
                        disabled={
                          currentImageIndex === selectedDriver.images.length - 1
                        }
                      >
                        <span className="sr-only">Previous</span>
                        <svg
                          className="cust_hist_page_icon"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          aria-hidden="true"
                        >
                          <path
                            fillRule="evenodd"
                            d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </button>
                    </li>
                    <li className="cust_hist_page_item" key="next">
                      <button
                        className="cust_hist_page_link cust_hist_page_next"
                        onClick={() =>
                          setCurrentImageIndex(currentImageIndex - 1)
                        }
                        disabled={currentImageIndex === 0}
                      >
                        <span className="sr-only">Next</span>
                        <svg
                          className="cust_hist_page_icon"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          aria-hidden="true"
                        >
                          <path
                            fillRule="evenodd"
                            d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </button>
                    </li>
                  </div>
                </>
              ) : (
                <p>No images available.</p>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button
                style={{
                  backgroundColor: "var(--primary-color)",
                  border: "none",
                  fontSize: "13px",
                  color: "#fff",
                  marginRight: "0.3rem",
                }}
                variant="success"
                onClick={handleDownloadAllImages}
              >
                Download All
              </Button>
              <Button
                style={{
                  backgroundColor: "var(--light-text)",
                  border: "none",
                  fontSize: "13px",
                  color: "#fff",
                }}
                variant="secondary"
                onClick={handleClose}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        )}
    </div>
  );
}

export default ACREnquiries;
